/**
 * Product SKU Display
 * Updates the displayed SKU when variant selection changes.
 * Subscribes to the variantChange pub/sub event and updates the
 * ProductSku-{sectionId} element with the new variant's SKU.
 */
document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
    const skuElement = document.getElementById(`ProductSku-${sectionId}`);

    if (skuElement) {
      skuElement.textContent = variant?.sku || '';
    }
  });
});
